<template>
  <div>
  
    <ChatModalClient
      :visible="visible"
      :chat="activeChat"
      @close="closeModal"
    />
  
  </div>
</template>

<script>
import ChatModalClient from './ChatModalClient.vue'
import { mapGetters, mapActions } from 'vuex'
import { 
  getDialog
} from '@/api/chatApi';

export default {
  components: { ChatModalClient },
  data() {
    return {
      visible: false,
      activeChat: null
    }
  },
  methods: {
    async openChatModal(clientId) {
      console.log(clientId);
      const chat = await getDialog({dialogId:clientId}) 
      if (chat) {
        this.activeChat = chat
        this.visible = true
      } else {
        console.warn('[ChatModalManager] Чат не найден для clientId:', clientId)
      }
      
    },

    closeModal() {
      this.visible = false
      this.activeChat = null
    }
  }
}
</script>

